import script from "./zw.vue?vue&type=script&setup=true&lang=js"
export * from "./zw.vue?vue&type=script&setup=true&lang=js"

import "./zw.vue?vue&type=style&index=0&id=1cbc1c8d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1cbc1c8d"]])

export default __exports__